import context from '../context'
import cookie from 'js-cookie'
import forOwn from 'lodash/forOwn'
import isEqual from 'lodash/isEqual'
import getComponentKey from '@/utils/getComponentKey'
import debug from 'debug'
const log = debug('app:store:localize')
const initialState = {
  data: null,
  localeDependentComponentKey: getComponentKey()
}

const actionTypes = {
  ResourcesLoaded: 'localize/ResourcesLoaded',
  LoadingResources: 'localize/LoadingResources'
}

export const actionCreators = {
  loadResources: locale => (dispatch, getState) => {
    const state = getState().localization
    if (!locale) {
      // get locale from cookie
      locale = cookie.get('locale')
    }
    if (locale && locale !== cookie.get('locale')) {
      cookie.set('locale', locale, { expires: 999 })
    }
    if (state.locale !== locale || !state.data) {
      actionCreators.reloadResources(locale)(dispatch, getState)
    }
  },
  reloadResources: locale => (dispatch, getState) => {
    if (locale) {
      const json = window.localStorage.getItem(`locale_${locale}`)
      if (json) {
        const data = JSON.parse(json)
        if (data) {
          onLocaleChanged(locale)
          dispatch({ type: actionTypes.ResourcesLoaded, data: data, locale: locale })
        }
      }
    }
    dispatch({ type: actionTypes.LoadingResources, locale: locale })
    context.api.localizationService.get(locale).then(response => {
      // if locale sent to server was undefined, server sends back a locale from settings (key "Cbi.Bsrs.Api.DefaultLocale")
      const { locale: loc, accountingArea, data } = response
      onLocaleChanged(loc)
      dispatch({ type: actionTypes.ResourcesLoaded, data: { accountingArea, data }, locale: loc })
      window.localStorage.setItem(`locale_${loc}`, JSON.stringify(response))
    }).catch(error => {
      log(`Error while loading resources for locale: ${locale}`, error)
      if (!getState().localization.data) { // when resx loading fails and there is no local resx cached, display resx keys
        dispatch({ type: actionTypes.ResourcesLoaded, data: { data: [] }, locale: locale })
      }
    })
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ResourcesLoaded:
      state = { ...transformData(action.data, state), locale: action.locale }
      break
    case actionTypes.LoadingResources:
      state = { ...state, loadingLocale: action.locale }
      break
    default: break
  }
  return state
}

function transformData (payload, previousState) {
  const accountingArea = payload.accountingArea
  let areaKeys = {}
  let keys = {}
  forOwn(payload.data, (value, key) => {
    key = key.replace(':', '.')
    let area = ''
    const areaIndex = key.indexOf('#')
    if (areaIndex > 0) {
      area = key.substring(areaIndex + 1)
      key = key.substring(0, areaIndex)
      if (area && area === accountingArea) {
        areaKeys[key] = true
        keys[key] = value
      }
    } else if (areaIndex < 0 || !areaKeys[area]) {
      keys[key] = value
    }
  })
  if (accountingArea !== previousState.accountingArea || !isEqual(keys, previousState.data)) {
    return {
      localeDependentComponentKey: getComponentKey(),
      accountingArea: accountingArea,
      data: keys
    }
  } else {
    return previousState
  }
}

function onLocaleChanged (locale) {
  document.documentElement.lang = locale
  if (locale === 'ar') { // condition for all rtl locales we use
    document.body.classList.add('rtl')
  } else {
    document.body.classList.remove('rtl')
  }
}



// WEBPACK FOOTER //
// ./src/store/Localize.js